import React,{useEffect,useState} from "react";
import {connect,useDispatch} from "react-redux";
import { Avatar } from '../../../base/avatar';
import __WaitingRoom from "./../../services/Chat"
import { getConferenceNameForTitle } from '../../../base/conference';
import {LobbyVisible,LobbyKnockers} from "./../../actions"

function KnockingParticipantList({is_owner,__RoomID}) {
    const dispatch = useDispatch();
    const [__participants,__setPartcipants] = useState([]);
    useEffect(()=>{
        if(is_owner){    
            dispatch(LobbyVisible(true));
            const onUpdate = __value => {
                if(!__value){
                    return false;
                }
                let filtered = __value instanceof Array ? __value.filter(__val=>__val.join===false && __val.approval===""):[];
                __setPartcipants(filtered);
                dispatch(LobbyKnockers(filtered));
            }
            __WaitingRoom.fetch_if_ref_exists(`/WaitingRoom/${__RoomID}/`).then(value=>{
                if(value){
                    __WaitingRoom.fetch_ref_on_update(`/WaitingRoom/${__RoomID}/`,onUpdate);
                }
            })
        }
    },[is_owner])
    return (
        <>
            {is_owner && __participants instanceof Array && __participants.length > 0 ? (
                <ul className="meet-participants-pop-screen">
                    {__participants.map((value, key) => {
                        return (
                            <li key={`participants_${key}`} onClick={()=>$("#InviteModal").modal("show")}>
                                <div class="partcipant-pop-dt">
                                    <span class="partcipant-img">
                                        <Avatar
                                            displayName = { value.name }
                                            size = { 48 }
                                            testId = 'knockingParticipant.avatar'
                                            url = { value.app_picture } />
                                    </span>
                                    <span class="participant-name"> 
                                        <h3>{value.name}</h3>
                                        <p>{value.name} is asking to join meeting</p>
                                    </span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </>
    );
}

function _mapStateToProps(state,ownProps){
    const {is_owner} = ownProps;    
    const __RoomID = getConferenceNameForTitle(state);
    return {is_owner,__RoomID};
}

export default connect(_mapStateToProps)(KnockingParticipantList);
